import formatFn from 'date-fns/format'

export function formatDate(date, format) {
  return formatFn(date, format)
}

export default formatDate
